import { render, staticRenderFns } from "./bg_button_section.vue?vue&type=template&id=34be6fd3&scoped=true&"
import script from "./bg_button_section.vue?vue&type=script&lang=js&"
export * from "./bg_button_section.vue?vue&type=script&lang=js&"
import style0 from "./bg_button_section.vue?vue&type=style&index=0&id=34be6fd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be6fd3",
  null
  
)

export default component.exports